(function () {
  // Find the section id from the toggle we injected
  const toggle = document.querySelector('[id^="AvailableNowToggle-"]');
  if (!toggle) return;

  const sectionId = toggle.id.replace('AvailableNowToggle-', '');

  // Dawn typically renders variant data as JSON somewhere in the product section.
  // We’ll try a few common IDs.
  const jsonEl =
    document.getElementById(`ProductJSON-${sectionId}`) ||
    document.querySelector(`#MainProduct-${sectionId} script[type="application/json"]`) ||
    document.querySelector('script[type="application/json"][data-product-json]') ||
    document.querySelector('script[type="application/json"]');

  if (!jsonEl) return;

  let product;
  try {
    product = JSON.parse(jsonEl.textContent);
  } catch (e) {
    return;
  }

  if (!product || !Array.isArray(product.variants)) return;

  // For “rings with many sizes”, size is usually option1 (only option),
  // or option2 if option1 is something else (e.g. Metal).
  // We'll use the option name “Size” if present; otherwise default to option1.
  const sizeOptionIndex = (() => {
    const opts = product.options || [];
    const idx = opts.findIndex(o => (o && o.name && o.name.toLowerCase() === 'size'));
    return idx >= 0 ? idx + 1 : 1; // 1-based (option1/2/3)
  })();

  const getSelectedOptions = () => {
    // Grab currently selected option values from Dawn variant picker inputs
    const root = document.getElementById(`MainProduct-${sectionId}`) || document;
    const selects = root.querySelectorAll('variant-selects select');
    const radios = root.querySelectorAll('variant-radios fieldset');

    // Build array of selected option values in order
    const selected = [];

    if (selects.length) {
      selects.forEach(sel => selected.push(sel.value));
    } else if (radios.length) {
      radios.forEach(fs => {
        const checked = fs.querySelector('input[type="radio"]:checked');
        selected.push(checked ? checked.value : null);
      });
    }

    return selected;
  };

  const computeAvailabilityBySize = () => {
    const selected = getSelectedOptions(); // [option1, option2, ...] (may include size)
    const sizeIdx0 = sizeOptionIndex - 1;

    // Return a map: sizeValue -> isAnyVariantAvailableGivenOtherSelections
    const map = new Map();

    for (const v of product.variants) {
      const sizeVal = v[`option${sizeOptionIndex}`];
      if (!sizeVal) continue;

      // Check if variant matches other selected options (excluding size itself)
      let matches = true;
      for (let i = 0; i < selected.length; i++) {
        if (i === sizeIdx0) continue;
        const selVal = selected[i];
        if (selVal && v[`option${i + 1}`] !== selVal) {
          matches = false;
          break;
        }
      }
      if (!matches) continue;

      const prev = map.get(sizeVal) || false;
      map.set(sizeVal, prev || !!v.available);
    }

    return map;
  };

  const markSoldOutOptions = () => {
    const availableBySize = computeAvailabilityBySize();
    const root = document.getElementById(`MainProduct-${sectionId}`) || document;

    // Handle radio buttons
    root.querySelectorAll('variant-radios input[type="radio"]').forEach(input => {
      const value = input.value;
      const isAvailable = availableBySize.get(value);

      const label = root.querySelector(`label[for="${input.id}"]`) || input.closest('label');
      if (!label) return;

      label.classList.toggle('variant-option--soldout', isAvailable === false);
    });

    // Handle select dropdowns (we’ll tag the <option>)
    root.querySelectorAll('variant-selects select').forEach(select => {
      // Only apply to the Size select if we can detect it
      const optName = select.closest('.product-form__input')?.querySelector('label')?.textContent?.toLowerCase() || '';
      const isSizeSelect = optName.includes('size');

      if (!isSizeSelect && (product.options?.length || 0) > 1) return;

      Array.from(select.options).forEach(opt => {
        const isAvailable = availableBySize.get(opt.value);
        opt.dataset.soldout = isAvailable === false ? 'true' : 'false';
      });
    });
  };

  const applyToggle = () => {
    const root = document.getElementById(`MainProduct-${sectionId}`) || document;
    root.classList.toggle('variant-fade-soldout', toggle.checked);
    markSoldOutOptions();
  };

  // Recompute whenever options change (metal selection affects which sizes are in stock)
  document.addEventListener('change', (e) => {
    if (e.target.closest('variant-radios') || e.target.closest('variant-selects')) {
      if (toggle.checked) markSoldOutOptions();
    }
  });

  toggle.addEventListener('change', applyToggle);

  // initial pass
  applyToggle();
})();
